import React from 'react';
import { colourString } from '../../../library';
export function ArrowIcon(_a) {
    var _b = _a.size, size = _b === void 0 ? 20 : _b, _c = _a.tone, tone = _c === void 0 ? 'accent-3' : _c, _d = _a.rotation, rotation = _d === void 0 ? 1 : _d;
    var rotationDegrees = (rotation - 1) * 90;
    return (React.createElement("svg", { fill: "none", viewBox: "0 0 12 8", width: size, height: size, style: { transform: "rotate(".concat(rotationDegrees, "deg)") } },
        React.createElement("path", { fill: colourString(tone), d: "m6.50461 7.3892 4.24219-4.11863c.6539-.63487.3525-2.11027-.4349-2.1291L1.68505.93524C.886965.916161.559247 2.40907 1.21873 3.05955l4.38471 4.32487c.2715.2678.62832.26969.90117.00478Z" })));
}
export default ArrowIcon;
